// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4577 ? "2b7b2d2a" : chunkId) + "." + {"4577":"7dc4af114ae7bd6d","5473":"58a31f136e6514be","6009":"e8c366cfab640ce4"}[chunkId] + ".js";
};